import { View } from 'react-native'
import Options from '@ui/elements/OptionBadge/Options'
import { OptionBadgeProps } from '@ui/elements/OptionBadge/types'
import OptionItem from '@order/modals/Checkout/LinkedOrders/OptionItem'

const methods: OptionBadgeProps[] = [
  {
    text: 'Terminal',
    status: 'default',
  },
  {
    text: 'Paylink',
    status: 'default',
  },
  {
    text: 'Installment',
    status: 'active',
  },
  {
    text: 'Invoice',
    status: 'disabled',
  },
]

export default function Orders() {
  return (
    <View className="h-full w-full flex-1 items-center justify-center gap-32 bg-white">
      <Options options={methods} />
      <View className="flex w-full flex-col gap-8">
        <OptionItem option="separately" />
        <OptionItem option="together" />
      </View>
    </View>
  )
}
